import React from 'react';
import PropTypes from 'prop-types';
import { PROFILE_BLOCKS } from '../../../../../../../services/utilityFunctions';
import ProfileBlockIcon from '../../../../../../profile/sidePanel/icons/ProfileBlockIcon';

export default function ProfileIcon({ block }) {
  return (
    <div className="news-item-image-profile">
      <ProfileBlockIcon block={block} />
    </div>
  );
}

ProfileIcon.propTypes = {
  block: PropTypes.oneOf(PROFILE_BLOCKS).isRequired,
};
